'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _components = {
	_$NumberIntervalFilter: {
		displayName: 'NumberIntervalFilter'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var NumberIntervalFilter = (function (_Component) {
	_inherits(NumberIntervalFilter, _Component);

	function NumberIntervalFilter() {
		_classCallCheck(this, _NumberIntervalFilter);

		_Component.apply(this, arguments);
	}

	NumberIntervalFilter.prototype.handleChange = function handleChange(e) {
		if (this.props.onChange) {
			this.props.onChange(this.getValue());
		}
	};

	NumberIntervalFilter.prototype.handleBlur = function handleBlur(e) {
		if (this.props.onBlur) {
			this.props.onBlur(this.getValue());
		}
	};

	NumberIntervalFilter.prototype.getValue = function getValue() {
		var v = e.target.value;
		var parts = v.split('-');
		var value = {
			from: null,
			to: null
		};
		if (parts.length == 1) {
			value.from = v;
			value.to = v;
		} else {
			value.from = parts[0].trim();
			value.to = parts[1].trim();
		}
		return _immutable2['default'].Map(value);
	};

	NumberIntervalFilter.prototype.render = function render() {
		var _this = this;

		return _react2['default'].createElement('input', _extends({ type: 'text'
		}, this.props, {
			className: 'form-control',
			value: typeof this.props.value != 'undefined' && this.props.value != null ? this.props.value.toString() : '',
			onChange: function (e) {
				return _this.handleChange(e);
			},
			onBlur: function (e) {
				return _this.handleBlur(e);
			}
		}));
	};

	_createClass(NumberIntervalFilter, null, [{
		key: 'filterDelay',
		value: true,
		enumerable: true
	}]);

	var _NumberIntervalFilter = NumberIntervalFilter;
	NumberIntervalFilter = _wrapComponent('_$NumberIntervalFilter')(NumberIntervalFilter) || NumberIntervalFilter;
	return NumberIntervalFilter;
})(_Component2['default']);

exports['default'] = NumberIntervalFilter;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/NumberIntervalFilter.js
 ** module id = 1016
 ** module chunks = 1
 **/